import { useState, useEffect } from 'react';
import axios from 'axios';
import { getClientId, getLocationId } from '../../utils';

const useEventGroups = () => {
  const [eventGroups, setEventGroups] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const events_api_url = import.meta.env.VITE_EVENTS_API_URL;
  const client_id = getClientId();
  const locationId = getLocationId();
  const groups_limit = 50;

  useEffect(() => {
    setLoading(true);
    axios.get(`${events_api_url}/groups?filter.status=1&limit=${groups_limit}&filter.locationId=${locationId}`, {
      headers: {
        'client_id': client_id
      }
    })
      .then(response => {
        const responseArray = response.data.data.data;
        const groupsArray = Array.isArray(responseArray) ? responseArray : [];
        setEventGroups(groupsArray);
      })
      .catch(error => {
        console.error('Error fetching event groups:', error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [events_api_url, client_id]);

  return { eventGroups, loading };
};

export default useEventGroups;
